import type { CalendarItem } from '@/types/contentPlanner';
import { PROCESSING_STATUSES } from './shared/bulkActionEligibility';

function createdTs(item: CalendarItem): number {
  if (!item.created_at) return 0;
  const t = Date.parse(item.created_at);
  return Number.isNaN(t) ? 0 : t;
}

/**
 * Order so in-progress blogs surface at the very top:
 * 1) actively-processing items first (uses the canonical PROCESSING_STATUSES set
 *    — incl. in_progress, the status the worker writes, and outline_pending), then
 * 2) most-recently-created first.
 * Used by both the Content Planner list and table views.
 */
export function byGenerationRecency(a: CalendarItem, b: CalendarItem): number {
  const aActive = PROCESSING_STATUSES.has(String(a.status)) ? 1 : 0;
  const bActive = PROCESSING_STATUSES.has(String(b.status)) ? 1 : 0;
  if (aActive !== bActive) return bActive - aActive;
  return createdTs(b) - createdTs(a);
}
